$bog_fragile_demo_retype_base1 $mol_view
	limit 10
	sub / <= limit
